import React, {useState} from "react";
import SearchField from "./SearchField";
import {Icon} from "@material-ui/core";

const SearchInput = ({searchKey}) => {
    const [isInSearch, setIsInSearch] = useState(false);

    function onChangeInSearch() {
        setIsInSearch(prev => !prev);
    }

    return (
        <>
            <div
                style={{
                    padding: 0,
                    display: 'inline-block'
                }}
            >
                <SearchField searchKey={searchKey} isInSearch={isInSearch} onChangeInSearch={onChangeInSearch}/>
            </div>
            <Icon fontSize={"small"}
                  onClick={(e) => {
                      e.stopPropagation();
                      onChangeInSearch()
                  }}
                  style={{
                      color: '#bebebe'
                  }}>
                search
            </Icon>
        </>
    )
}
export default SearchInput;